import { useState } from 'react';

export const useCheckout = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    streetAddress: '',
    apartment: '',
    city: '',
    province: '',
    postalCode: '',
    country: 'Canada',
    phone: '',
    shippingMethod: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Validate postal code based on country
  const validatePostalCode = (postalCode, country) => {
    switch(country) {
      case 'Canada':
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(postalCode);
      case 'United States':
        return /^\d{5}(-\d{4})?$/.test(postalCode);
      default:
        // Less strict validation for international postal codes
        return postalCode.length >= 3;
    }
  };

  // Validate required fields
  const validateForm = () => {
    const requiredFields = [
      'firstName',
      'lastName',
      'email',
      'streetAddress',
      'city',
      'province',
      'postalCode',
      'country',
      'phone',
      'shippingMethod'
    ];

    const isValid = requiredFields.every(field => {
      if (field === 'shippingMethod') {
        return formData[field] !== null;
      }
      return formData[field] && formData[field].trim() !== '';
    });

    // Additional validation for specific fields
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
    const isValidPostalCode = validatePostalCode(formData.postalCode, formData.country);
    const isValidPhone = /^\+?[\d\s-()]{8,}$/.test(formData.phone.trim());

    return isValid && isValidEmail && isValidPostalCode && isValidPhone;
  };

  // Format the full address for Square's API
  const getFormattedAddress = () => {
    const parts = [
      formData.streetAddress,
      formData.apartment,
      formData.city,
      formData.province,
      formData.postalCode,
      formData.country
    ].filter(Boolean); // Remove empty values

    return parts.join(', ');
  };

  return {
    formData,
    handleChange,
    getFormattedAddress,
    validateForm
  };
};